var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeezerLogoinline = function SvgDeezerLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 14,
    viewBox: "0 0 25 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C24",
    d: "M0 13.909h4.541v-1.377H0zm0-1.79h4.541V10.74H0zm0-1.79h4.541V8.952H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7836C",
    d: "M0 8.538h4.541V7.162H0zm0-1.79h4.541V5.371H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF200",
    d: "M5.092 13.909h4.541v-1.377H5.092zm0-1.79h4.541V10.74H5.092zm0-1.79h4.541V8.952H5.092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    d: "M10.184 13.909h4.541v-1.377h-4.541zm0-1.79h4.541v-1.377h-4.541zm0-1.79h4.541V8.952h-4.541z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F780C5",
    d: "M10.184 8.538h4.541V7.162h-4.541zm0-1.79h4.541V5.37h-4.541zm0-1.79h4.541V3.58h-4.541zm0-1.79h4.541V1.791h-4.541z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2DB18",
    d: "M15.275 13.909h4.542v-1.377h-4.542zm0-1.79h4.542V10.74h-4.542zm0-1.79h4.542V8.952h-4.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9ED84",
    d: "M15.275 8.538h4.542V7.162h-4.542zm0-1.79h4.542V5.371h-4.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59CAF6",
    d: "M20.367 13.909h4.542v-1.377h-4.542zm0-1.79h4.542V10.74h-4.542zm0-1.791h4.542V8.951h-4.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2E6FA",
    d: "M20.367 8.538h4.542V7.161h-4.542zm0-1.79h4.542V5.371h-4.542zm0-1.79h4.542V3.58h-4.542zm0-1.791h4.542V1.79h-4.542zm0-1.79h4.542V0h-4.542z"
  }))));
};
export default SvgDeezerLogoinline;